import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { peopleQueryKeys } from "./queryKeys";
import { IPerson } from "./../../models/person/Person";

export function usePeopleMutations(showNotifications: boolean = true) {
  const queryClient = useQueryClient();
  const { put, post, del } = useApiHelper();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("Contact");

  const create = useMutation((person: IPerson) => post(`/person`, person), {
    ...(showNotifications && saveHandlers),
    onSuccess: () => {
      queryClient.invalidateQueries(peopleQueryKeys._base());
      if (showNotifications) {
        saveHandlers.onSuccess?.();
      }
    },
  });

  const update = useMutation(
    (person: IPerson) => put(`/person/${person.id}`, person),
    {
      ...(showNotifications && saveHandlers),
      onSuccess: () => {
        queryClient.invalidateQueries(peopleQueryKeys._base());
        if (showNotifications) {
          saveHandlers.onSuccess?.();
        }
      },
    }
  );

  const remove = useMutation((personId: string) => del(`/person/${personId}`), {
    ...(showNotifications && deleteHandlers),
    onSuccess: () => {
      queryClient.invalidateQueries(peopleQueryKeys._base());
      if (showNotifications) {
        deleteHandlers.onSuccess?.();
      }
    },
  });

  return {
    create,
    update,
    remove,
  };
}
